
export const DRAWER_NAME = {
    HISTORY_MODAL: 'history-modal',
    HISTORY_WRAPPER: 'history-wrapper',
    HISTORY_TIMELINE_POPOVER: 'timeline-popover',
    PROPERTY_LIST: 'property-list',
    PERSON_LIST: 'person-list',
    DEMAND_LIST: 'demand-list',
    RELATION: 'add-relation',
    PERSON_RELATION: 'person-relation',
    PERSON_NEW_FORM: 'person-new-form',
    PERSON_EDIT_FORM: 'person-edit-form',
    PROPERTY_NEW_FORM: 'property-new-form',
    PERSON_DETAIL: 'person-quick-view-full-info',
    PROPERTY_DETAIL: 'property-quick-view-full-info',
    PROJECT_DETAIL: 'project-quick-view-full-info',
    DEMAND_DETAIL: 'demand-quick-view-full-info',
    DEMAND_NEW_FORM: 'demand-new-form',
    TASK_DETAIL: 'task-quick-view-full-info',
    SIGN_DOCUMENT: 'sign-document',
    MIJVERHUIS_MODAL: 'mijnverhuis-modal',
    SMOOVED_MODAL: 'smooved-modal',
    KORFINE_MODAL: 'korfine-modal',
    CERTINERGIE_MODAL: 'Certinergie-modal',
    CERTIPLUS_MODAL: 'Certiplus-modal',
    AUTO_CAPTURE: 'auto-capture',
    MATCHING_DEMAND: 'matching-demand',
    MATCHING_PROPERTY: 'matching-property',
    COMPANY_NEW_FORM: 'company-new-form',
    DEMAND_CRITERIA: 'demand-criteria',
    TASK_NEW_FORM: "task-new-form",
    VIDEO_MANAGEMENT: 'video-management'
}